"use client";

import React from "react";
import { Star, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const reviews = [{
  text: "We scan the market for deeply undervalued and transformative companies. Macro serves as a directional filter — we identify structural shifts early and position before the opportunity becomes obvious.",
  name: "Phase 01",
  location: "Macro & On-Chain Analysis",
  initials: "01"
}, {
  text: "Conviction Filtering: Ideas are stress-tested against rigorous risk/reward parameters. We only move forward with high-conviction opportunities that offer asymmetric upside potential.",
  name: "Phase 02",
  location: "Risk/Reward Assessment",
  initials: "02"
}, {
  text: "Execution Strategy: Precision entry and exit signals are defined. We provide the technical framework to capture the move while protecting capital through disciplined position sizing.",
  name: "Phase 03",
  location: "Signal & Exit Management",
  initials: "03"
}];
export default function CustomerReviews() {
  return <section data-section-id="252424" id="the-analysis-framework" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        {}
        <div className="flex flex-col items-center text-center mb-12">
          <span className="text-primary font-bold text-xs tracking-widest uppercase font-default">
            The Methodology
          </span>
          <div className="h-0.5 w-8 bg-primary mt-2 mb-6 rounded-md"></div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default tracking-tight">
            The Analysis Framework
          </h2>
          <p className="text-muted-foreground mt-4 max-w-2xl text-lg font-sans">
            A systematic approach to identifying high-conviction opportunities in crypto and equities.
          </p>
          
          <div className="mt-8">
            <Link to="/HomePage">
              
            </Link>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review, i) => <Card key={i} data-index={i} className="border-0 border-l-4 border-l-primary shadow-lg rounded-md bg-card/50 backdrop-blur-md overflow-hidden">
              <CardContent className="p-6 flex flex-col h-full">
                {}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, j) => <Star key={j} className="size-4 fill-primary text-primary" />)}
                </div>
                
                {}
                <p className="text-foreground flex-grow leading-relaxed font-sans">
                  {review.text}
                </p>
                
                {}
                <div className="flex items-center mt-8 pt-4 border-t border-border/20">
                  <div className="size-10 rounded-md bg-primary/10 border border-primary/30 flex items-center justify-center text-primary font-mono font-bold shrink-0">
                    {review.initials}
                  </div>
                  <div className="ml-3">
                    <p className="font-bold text-foreground text-sm font-default uppercase tracking-wider">
                      {review.name}
                    </p>
                    <p className="text-xs text-muted-foreground mt-0.5 font-mono">
                      {review.location}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}